import React, { useState } from 'react';

import { Box } from '@mui/material';

import { object, ref, string, ValidationError } from 'yup';

import Axios from '../../../Assets/Axios/Axios';

import PasswordField from '../../PasswordField';
import { TypoPoppins } from '../../Typo';
import { LoadingButton } from '../../Loaders';
import { PasswordChange } from '../../../Server/Query';
import { useToastContext } from '../../../Context/ToastContext';

function ResetPassword({ closeModal, email }) {
  const { showToastMessage } = useToastContext();

  const [formFields, setFormFields] = useState({
    password: '',
    confirmPassword: '',
  });
  const [formErrors, setFormErrors] = useState({
    password: null,
    confirmPassword: null,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  function handleChange({ target: { name, value } }) {
    setFormFields(currentState => ({ ...currentState, [name]: value }));
  }

  async function handleSubmit(event) {
    event.preventDefault();
    setIsSubmitting(true);
    try {
      setFormErrors({ password: null, confirmPassword: null });
      const fields = await schema.validate(formFields, { abortEarly: false });

      const query = PasswordChange({
        password: fields.password,
        email,
        user: 'EVENT_BOOKER',
      });

      const response = await Axios(query);

      if (response.errors) {
        showToastMessage('Something went wrong, Failed to verify your code');
        return undefined;
      }

      showToastMessage('Password reset successful', 'success');
      closeModal();
    } catch (error) {
      if (error instanceof ValidationError) {
        setFormErrors(currentErrors => ({
          ...currentErrors,
          ...error.inner.reduce((errors, err) => {
            errors[err.path] = err.message;
            return errors;
          }, {}),
        }));
      }
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <Box
      component='form'
      onSubmit={handleSubmit}
      px={{ xs: 0.5, sm: 3 }}
      py={6}
    >
      <TypoPoppins
        variant='h6'
        variantMapping={{ h6: 'h1' }}
        textAlign='center'
      >
        Create New Password
      </TypoPoppins>

      <TypoPoppins textAlign='center' color='text.secondary' mb={4}>
        Your new password must be different <wbr /> from previously used
        password
      </TypoPoppins>

      <Box display='grid' gap={2} gridTemplateColumns='1fr 2fr 1fr'>
        <PasswordField
          name='password'
          sx={{ gridColumn: 'span 3' }}
          fullWidth
          value={formFields.password}
          onChange={handleChange}
          error={Boolean(formErrors.password)}
          helperText={formErrors.password}
        />
        <PasswordField
          name='confirmPassword'
          sx={{ gridColumn: 'span 3' }}
          fullWidth
          value={formFields.confirmPassword}
          onChange={handleChange}
          error={Boolean(formErrors.confirmPassword)}
          helperText={formErrors.confirmPassword}
        />

        <LoadingButton
          fullWidth
          type='submit'
          color='blue'
          isLoading={isSubmitting}
          sx={{ mx: 'auto', mt: 1, gridColumn: { xs: 'span 3', sm: '2 / 3' } }}
        >
          Submit
        </LoadingButton>
      </Box>
    </Box>
  );
}

const schema = object({
  password: string().required().min(6).label('Password'),
  confirmPassword: string()
    .required()
    .oneOf([ref('password')], 'Passwords do not match')
    .label('Confirm Password'),
});

export default React.memo(ResetPassword);
